/**
 * Мемоизация последнего вызова по ссылкам входов: compute пересчитывается,
 * только если хотя бы один вход из getInputs изменился по ссылке (===).
 * Замена reselect для пары селекторов — ставить зависимость ради них не стоит.
 */
export const memoizeByRefs = (getInputs, compute) => {
  let lastInputs = null;
  let lastResult;

  return (...args) => {
    const inputs = getInputs(...args);
    const isSame = lastInputs !== null
      && lastInputs.length === inputs.length
      && inputs.every((input, index) => input === lastInputs[index]);
    if (!isSame) {
      lastResult = compute(...args);
      lastInputs = inputs;
    }
    return lastResult;
  };
};
